/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetPalDetailedCoverSheetResponse } from './GetPalDetailedCoverSheetResponse';
import {
    GetPalDetailedCoverSheetResponseFromJSON,
    GetPalDetailedCoverSheetResponseFromJSONTyped,
    GetPalDetailedCoverSheetResponseToJSON,
    GetPalDetailedCoverSheetResponseToJSONTyped,
} from './GetPalDetailedCoverSheetResponse';

/**
 * 
 * @export
 * @interface GetPalDetailedCoverSheet200Response
 */
export interface GetPalDetailedCoverSheet200Response {
    /**
     * 
     */
    data?: GetPalDetailedCoverSheetResponse;
}

/**
 * Check if a given object implements the GetPalDetailedCoverSheet200Response interface.
 */
export function instanceOfGetPalDetailedCoverSheet200Response(value: object): value is GetPalDetailedCoverSheet200Response {
    return true;
}

export function GetPalDetailedCoverSheet200ResponseFromJSON(json: any): GetPalDetailedCoverSheet200Response {
    return GetPalDetailedCoverSheet200ResponseFromJSONTyped(json, false);
}

export function GetPalDetailedCoverSheet200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPalDetailedCoverSheet200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : GetPalDetailedCoverSheetResponseFromJSON(json['data']),
    };
}

export function GetPalDetailedCoverSheet200ResponseToJSON(json: any): GetPalDetailedCoverSheet200Response {
    return GetPalDetailedCoverSheet200ResponseToJSONTyped(json, false);
}

export function GetPalDetailedCoverSheet200ResponseToJSONTyped(value?: GetPalDetailedCoverSheet200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': GetPalDetailedCoverSheetResponseToJSON(value['data']),
    };
}

